import { GoogleOAuthProvider } from "@react-oauth/google";
import { captureException } from "@sentry/react";
import type { LinksFunction } from "react-router";
import { Links, Meta, Outlet, Scripts, ScrollRestoration, isRouteErrorResponse, useRouteError } from "react-router";
import { ErrorPage } from "~/components/ErrorPage";
import { TooltipProvider } from "~/components/ui/Tooltip";
import stylesheet from "~/tailwind.css?url";

export const links: LinksFunction = () => [
  { rel: "icon", href: "/favicon.ico", sizes: "32x32" },
  { rel: "icon", href: "/favicon.svg", type: "image/svg+xml" },
  { rel: "stylesheet", href: stylesheet },
];

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <Meta />
        <Links />
      </head>
      <body>
        {children}
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}

export const ErrorBoundary = () => {
  const error = useRouteError();
  captureException(error);

  if (isRouteErrorResponse(error)) {
    return <ErrorPage statusCode={error.status} />;
  }
  return <ErrorPage statusCode={500} />;
};

export default function App() {
  const clientID = import.meta.env.VITE_GOOGLE_LOGIN_CLIENT_ID;
  return (
    <GoogleOAuthProvider clientId={clientID}>
      <TooltipProvider>
        <Outlet />
      </TooltipProvider>
    </GoogleOAuthProvider>
  );
}
